import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Para quién está diseñado el Kit de Tarot Terapéutico?',
  answer: 'Está diseñado tanto para quienes están comenzando a incorporar el Tarot a su práctica como para terapeutas y lectores que buscan una estructura más clara para sus sesiones.'
}, {
  question: '¿Necesito conocimientos previos de Tarot?',
  answer: 'No es necesario. El kit incluye una base práctica para comprender las cartas y recursos organizados para avanzar con mayor seguridad.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Una vez confirmada tu compra, recibís acceso inmediato al material digital para consultar desde cualquier dispositivo.'
}, {
  question: '¿El acceso es de por vida?',
  answer: 'Sí. El acceso al material es de por vida, para que puedas volver a consultarlo siempre que lo necesites.'
}, {
  question: '¿Qué pasa si el sistema no es lo que esperaba?',
  answer: 'Confiamos plenamente en la calidad de nuestro material. Por eso, contás con una garantía de satisfacción de 7 días. Si sentís que el sistema no aporta valor a tu práctica personal o profesional, podés solicitar el reembolso total de tu inversión.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-transparent py-12 sm:py-16" data-id="element-131" data-mp="1fqq94x4wtx6k">
      <div className="mx-auto max-w-3xl px-4" data-id="element-132" data-mp="11w7fba3181zv">
        <div className="mb-8 text-center sm:mb-10" data-id="element-133" data-mp="11ve5u1couye1">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.55,
          ease: [0.22, 1, 0.36, 1]
        }} className="mb-4 font-magical text-4xl font-bold italic text-purple-950 md:text-6xl" data-id="element-134" data-mp="16oqugbhdb56s">
            Preguntas <span className="text-purple-600" data-id="element-135" data-mp="mzyisgaj02r5">Frecuentes</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.45,
          delay: 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} className="text-[10px] font-black uppercase tracking-[0.2em] text-purple-600" data-id="element-136" data-mp="n22on3rzjbu2">
            Despejá tus dudas y comenzá hoy
          </motion.p>
        </div>
        <div className="space-y-4" data-id="element-137" data-mp="38l93z5wj5d1f">
          {faqs.map((faq, index) => <motion.div key={faq.question} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.5,
          delay: index * 0.06,
          ease: [0.22, 1, 0.36, 1]
        }} className="group overflow-hidden rounded-[2rem] border border-purple-100 bg-white shadow-lg premium-shadow" data-id="element-138" data-mp="38j54r19kt27h" data-mpi={index}>
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className={`flex w-full items-center justify-between p-6 text-left transition-[background-color] duration-200 ease-out md:p-8 ${openIndex === index ? 'bg-purple-50/50' : 'hover:bg-purple-50/30'}`} aria-expanded={openIndex === index} data-id="element-139" data-mp="1j61jsgs06n33">
                <span className="pr-8 font-magical text-lg font-bold italic text-purple-950 md:text-xl" data-id="element-140" data-mp="cfni7yajvojj">{faq.question}</span>
                <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-[background-color,color,transform] duration-200 ease-out ${openIndex === index ? 'rotate-180 bg-purple-600 text-white' : 'bg-purple-50 text-purple-400 group-hover:text-purple-600'}`} data-id="element-141" data-mp="hdyqi4l75qzn">
                  <ChevronDown size={20} data-id="element-142" data-mp="vf1foq7hnhes" />
                </div>
              </button>
              <AnimatePresence initial={false} data-id="element-143" data-mp="2s7l2tan4zc4v">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-144" data-mp="2x5wb3gxs9ekz">
                    <div className="px-6 pb-8 md:px-8" data-id="element-145" data-mp="2btvsjmueeck9">
                      <div className="border-t border-purple-100/50 pt-4 text-base leading-relaxed text-zinc-600 md:text-lg" data-id="element-146" data-mp="2btdz0xz4ecg1">{faq.answer}</div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.15
      }} transition={{
        duration: 0.45,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1]
      }} className="mt-8 text-center sm:mt-10" data-id="element-147" data-mp="1e887tz7b1iok">
          <p className="text-sm italic text-zinc-400" data-id="element-148" data-mp="10dfi67xpam49">¿Tenés otra consulta? Escribinos y te ayudamos a decidir.</p>
        </motion.div>
      </div>
    </section>;
}